// ThankYouPage.jsx
import React, { useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './ThankYouPage.scss';

const ThankYouPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const hasRefreshed = useRef(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Check if this is a refresh
        // const performanceEntries = performance.getEntriesByType('navigation');
        // const isRefresh = performanceEntries.length > 0 && 
        //                  performanceEntries[0].type === 'reload';

        // if (isRefresh && !hasRefreshed.current) {
        //     hasRefreshed.current = true;
        //     // Redirect to contact page on refresh
        //     navigate('/contact', { 
        //         replace: true,
        //         state: { 
        //             message: 'Thank you page cannot be refreshed. Please submit the form again.'
        //         }
        //     });
        //     return;
        // }

        // // Fire Google Tag for the thank you page (only on initial load)
        // if (window.gtag && !hasRefreshed.current) {
        //     window.gtag('event', 'conversion', {
        //         'send_to': 'AW-17805059433',
        //         'value': 1.0,
        //         'currency': 'USD',
        //         'transaction_id': id
        //     });

        //     window.gtag('event', 'page_view', {
        //         'page_title': 'Thank You',
        //         'page_location': window.location.href,
        //         'page_path': `/thank-you/${id}`,
        //         'submission_id': id,
        //         'conversion_type': 'contact_form'
        //     });
        // }

        // Prevent user from refreshing via keyboard
        const handleKeyDown = (e) => {
            if ((e.ctrlKey && e.key === 'r') || // Ctrl+R
                (e.metaKey && e.key === 'r') || // Cmd+R
                e.key === 'F5') { // F5
                e.preventDefault();
                navigate('/contact', { 
                    replace: true,
                    state: { 
                        message: 'Refreshing is not allowed. Please submit the form again.'
                    }
                });
            }
        };

        // Prevent user from closing/reloading tab
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
            return '';
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [id, navigate]);

    const handleNewMessage = () => {
        navigate('/contact');
    };

    return (
        <div className="thank-you-page">
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col lg="8" className="text-center">
                        <div className="thank-you-content">
                            {/* Success Icon */}
                            <div className="success-icon mb-4">
                                <div className="icon-circle">
                                    <i className="fas fa-check"></i>
                                </div>
                            </div>

                            {/* Thank You Message */}
                            <h1 className="display-4 mb-4 fw-bold text-gradient">
                                Thank You!
                            </h1>

                            <p className="lead mb-4 text-muted">
                                Your message has been received successfully. Our team will contact you within 24 hours.
                            </p>

                            {/* Warning about page refresh */}
                            <div className="alert alert-warning mb-4" role="alert">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                <strong>Note:</strong> Refreshing this page will redirect you to the contact form.
                            </div>

                            {/* Submission ID */}
                            <div className="submission-details mb-4 p-4 bg-light rounded">
                                <h5 className="mb-3">Submission Details</h5>
                                <p className="mb-2">
                                    <strong>Submission ID:</strong> {id}
                                </p>
                            </div>

                            {/* Action Buttons */}
                            <div className="action-buttons d-flex flex-column flex-sm-row gap-3 justify-content-center">
                                <Button
                                    tag={Link}
                                    to="/services"
                                    color="light"
                                    size="lg"
                                    className="px-5"
                                >
                                    <i className="fas fa-arrow-left me-2"></i>
                                    Back to Services
                                </Button>
                                <Button
                                    color="primary"
                                    size="lg"
                                    className="px-5"
                                    onClick={handleNewMessage}
                                >
                                    <i className="fas fa-paper-plane me-2"></i>
                                    Send Another Message
                                </Button>
                            </div>

                            {/* Return Home Link */}
                            <div className="mt-4">
                                <Link to="/" className="text-decoration-none">
                                    <i className="fas fa-home me-2"></i>
                                    Return to Homepage
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ThankYouPage;